namespace RioERP.Carts {
    export interface CartProductBillingItemsRow {
        Id?: number;
        CartId?: number;
        CartProductsId?: number;
        GrossAmount?: number;
        DiscountAmount?: number;
        NetAmount?: number;
        TaxCategoryId?: number;
        ProductBillingItemId?: number;
        InvoiceCompanyId?: number;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        TaxableAmount?: number;
        CartName?: string;
        CartFranchiseeId?: number;
        CartCustomerId?: number;
        CartCustomerName?: string;
        CartCustomerEmail1?: string;
        CartCustomerEmail2?: string;
        CartCustomerMobile1?: string;
        CartCustomerMobile2?: string;
        CartShippingAddress1?: string;
        CartShippingAddress2?: string;
        CartShippingCity?: string;
        CartShippingStateId?: number;
        CartShippingPincode?: number;
        CartEInvoiceTo?: number;
        CartInvoiceCompanyId?: number;
        CartDiscountCoupon?: string;
        CartDiscountAmount?: number;
        CartGrossAmount?: number;
        CartNetAmount?: number;
        CartTaxableAmount?: number;
        CartEFranchiseeDiscountType?: number;
        CartEFranchiseeDiscount?: number;
        CartFranchiseeDiscountValue?: number;
        CartFranchiseeDiscountAmount?: number;
        CartInsertUserId?: number;
        CartInsertDate?: string;
        CartUpdateUserId?: number;
        CartUpdateDate?: string;
        CartIsActive?: boolean;
        CartProductsCartId?: number;
        CartProductsProductId?: number;
        CartProductsQuantity?: number;
        CartProductsCost?: number;
        CartProductsGrossAmount?: number;
        CartProductsDiscountAmt?: number;
        CartProductsNetAmount?: number;
        CartProductsTaxableAmount?: number;
        CartProductsSerialKey?: string;
        CartProductsHasPendrive?: boolean;
        CartProductsHasBooks?: boolean;
        CartProductsHasCourier?: boolean;
        CartProductsDownloadUrl1?: string;
        CartProductsDownloadUrl2?: string;
        CartProductsIsActive?: boolean;
        CartProductsInvoiceCompanyId?: number;
        CartProductsFranchiseeDiscountAmount?: number;
        CartProductsFranchiseeDiscountValue?: number;
        CartProductsEFranchiseeDiscountType?: number;
        CartProductsEOpens?: number;
        CartProductsEWatchTime?: number;
        CartProductsEValidity?: number;
        CartProductsEValidityType?: number;
        CartProductsValidTill?: string;
        CartProductsTotalAllowedDuration?: number;
        CartProductsAllowedDevices?: string;
        CartProductsIsLive?: boolean;
        CartProductsEAccessStatus?: number;
        CartProductsIsTemplateSerialKey?: boolean;
        CartProductsInsertUserId?: number;
        CartProductsInsertDate?: string;
        CartProductsUpdateUserId?: number;
        CartProductsUpdateDate?: string;
        CartProductsNote?: string;
        CartProductsESerialkeyStatus?: number;
        TaxCategoryName?: string;
        TaxCategoryIsActive?: boolean;
        TaxCategoryInsertUserId?: number;
        TaxCategoryInsertDate?: string;
        TaxCategoryUpdateUserId?: number;
        TaxCategoryUpdateDate?: string;
        ProductBillingItemProductId?: number;
        ProductBillingItemBillingItemName?: string;
        ProductBillingItemGrossAmount?: number;
        ProductBillingItemEDiscountType?: number;
        ProductBillingItemTaxCategoryId?: number;
        ProductBillingItemHsnMasterId?: number;
        ProductBillingItemIncludingTax?: boolean;
        ProductBillingItemInvoiceCompanyId?: number;
        ProductBillingItemSpecialGrossAmount?: number;
        ProductBillingItemStartDate?: string;
        ProductBillingItemEndDate?: string;
        ProductBillingItemIsActive?: boolean;
        ProductBillingItemInsertUserId?: number;
        ProductBillingItemInsertDate?: string;
        ProductBillingItemUpdateUserId?: number;
        ProductBillingItemUpdateDate?: string;
        InvoiceCompanyName?: string;
        InvoiceCompanyAddress?: string;
        InvoiceCompanyGstIn?: string;
        InvoiceCompanyInvoiceCode?: string;
        InvoiceCompanyIsTaxApplicable?: boolean;
        InvoiceCompanyInvoiceChangeDate?: string;
        InvoiceCompanyIsDefault?: boolean;
        InvoiceCompanyFooterNote?: string;
        InvoiceCompanyLogo1?: string;
        InvoiceCompanyLogo2?: string;
        InvoiceCompanyStampImage?: string;
        InvoiceCompanyDisableInvoiceGenration?: boolean;
        InvoiceCompanyTaxApplicable?: number;
    }

    export namespace CartProductBillingItemsRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Carts.CartProductBillingItems';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            CartId = "CartId",
            CartProductsId = "CartProductsId",
            GrossAmount = "GrossAmount",
            DiscountAmount = "DiscountAmount",
            NetAmount = "NetAmount",
            TaxCategoryId = "TaxCategoryId",
            ProductBillingItemId = "ProductBillingItemId",
            InvoiceCompanyId = "InvoiceCompanyId",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            TaxableAmount = "TaxableAmount",
            CartName = "CartName",
            CartFranchiseeId = "CartFranchiseeId",
            CartCustomerId = "CartCustomerId",
            CartCustomerName = "CartCustomerName",
            CartCustomerEmail1 = "CartCustomerEmail1",
            CartCustomerEmail2 = "CartCustomerEmail2",
            CartCustomerMobile1 = "CartCustomerMobile1",
            CartCustomerMobile2 = "CartCustomerMobile2",
            CartShippingAddress1 = "CartShippingAddress1",
            CartShippingAddress2 = "CartShippingAddress2",
            CartShippingCity = "CartShippingCity",
            CartShippingStateId = "CartShippingStateId",
            CartShippingPincode = "CartShippingPincode",
            CartEInvoiceTo = "CartEInvoiceTo",
            CartInvoiceCompanyId = "CartInvoiceCompanyId",
            CartDiscountCoupon = "CartDiscountCoupon",
            CartDiscountAmount = "CartDiscountAmount",
            CartGrossAmount = "CartGrossAmount",
            CartNetAmount = "CartNetAmount",
            CartTaxableAmount = "CartTaxableAmount",
            CartEFranchiseeDiscountType = "CartEFranchiseeDiscountType",
            CartEFranchiseeDiscount = "CartEFranchiseeDiscount",
            CartFranchiseeDiscountValue = "CartFranchiseeDiscountValue",
            CartFranchiseeDiscountAmount = "CartFranchiseeDiscountAmount",
            CartInsertUserId = "CartInsertUserId",
            CartInsertDate = "CartInsertDate",
            CartUpdateUserId = "CartUpdateUserId",
            CartUpdateDate = "CartUpdateDate",
            CartIsActive = "CartIsActive",
            CartProductsCartId = "CartProductsCartId",
            CartProductsProductId = "CartProductsProductId",
            CartProductsQuantity = "CartProductsQuantity",
            CartProductsCost = "CartProductsCost",
            CartProductsGrossAmount = "CartProductsGrossAmount",
            CartProductsDiscountAmt = "CartProductsDiscountAmt",
            CartProductsNetAmount = "CartProductsNetAmount",
            CartProductsTaxableAmount = "CartProductsTaxableAmount",
            CartProductsSerialKey = "CartProductsSerialKey",
            CartProductsHasPendrive = "CartProductsHasPendrive",
            CartProductsHasBooks = "CartProductsHasBooks",
            CartProductsHasCourier = "CartProductsHasCourier",
            CartProductsDownloadUrl1 = "CartProductsDownloadUrl1",
            CartProductsDownloadUrl2 = "CartProductsDownloadUrl2",
            CartProductsIsActive = "CartProductsIsActive",
            CartProductsInvoiceCompanyId = "CartProductsInvoiceCompanyId",
            CartProductsFranchiseeDiscountAmount = "CartProductsFranchiseeDiscountAmount",
            CartProductsFranchiseeDiscountValue = "CartProductsFranchiseeDiscountValue",
            CartProductsEFranchiseeDiscountType = "CartProductsEFranchiseeDiscountType",
            CartProductsEOpens = "CartProductsEOpens",
            CartProductsEWatchTime = "CartProductsEWatchTime",
            CartProductsEValidity = "CartProductsEValidity",
            CartProductsEValidityType = "CartProductsEValidityType",
            CartProductsValidTill = "CartProductsValidTill",
            CartProductsTotalAllowedDuration = "CartProductsTotalAllowedDuration",
            CartProductsAllowedDevices = "CartProductsAllowedDevices",
            CartProductsIsLive = "CartProductsIsLive",
            CartProductsEAccessStatus = "CartProductsEAccessStatus",
            CartProductsIsTemplateSerialKey = "CartProductsIsTemplateSerialKey",
            CartProductsInsertUserId = "CartProductsInsertUserId",
            CartProductsInsertDate = "CartProductsInsertDate",
            CartProductsUpdateUserId = "CartProductsUpdateUserId",
            CartProductsUpdateDate = "CartProductsUpdateDate",
            CartProductsNote = "CartProductsNote",
            CartProductsESerialkeyStatus = "CartProductsESerialkeyStatus",
            TaxCategoryName = "TaxCategoryName",
            TaxCategoryIsActive = "TaxCategoryIsActive",
            TaxCategoryInsertUserId = "TaxCategoryInsertUserId",
            TaxCategoryInsertDate = "TaxCategoryInsertDate",
            TaxCategoryUpdateUserId = "TaxCategoryUpdateUserId",
            TaxCategoryUpdateDate = "TaxCategoryUpdateDate",
            ProductBillingItemProductId = "ProductBillingItemProductId",
            ProductBillingItemBillingItemName = "ProductBillingItemBillingItemName",
            ProductBillingItemGrossAmount = "ProductBillingItemGrossAmount",
            ProductBillingItemEDiscountType = "ProductBillingItemEDiscountType",
            ProductBillingItemTaxCategoryId = "ProductBillingItemTaxCategoryId",
            ProductBillingItemHsnMasterId = "ProductBillingItemHsnMasterId",
            ProductBillingItemIncludingTax = "ProductBillingItemIncludingTax",
            ProductBillingItemInvoiceCompanyId = "ProductBillingItemInvoiceCompanyId",
            ProductBillingItemSpecialGrossAmount = "ProductBillingItemSpecialGrossAmount",
            ProductBillingItemStartDate = "ProductBillingItemStartDate",
            ProductBillingItemEndDate = "ProductBillingItemEndDate",
            ProductBillingItemIsActive = "ProductBillingItemIsActive",
            ProductBillingItemInsertUserId = "ProductBillingItemInsertUserId",
            ProductBillingItemInsertDate = "ProductBillingItemInsertDate",
            ProductBillingItemUpdateUserId = "ProductBillingItemUpdateUserId",
            ProductBillingItemUpdateDate = "ProductBillingItemUpdateDate",
            InvoiceCompanyName = "InvoiceCompanyName",
            InvoiceCompanyAddress = "InvoiceCompanyAddress",
            InvoiceCompanyGstIn = "InvoiceCompanyGstIn",
            InvoiceCompanyInvoiceCode = "InvoiceCompanyInvoiceCode",
            InvoiceCompanyIsTaxApplicable = "InvoiceCompanyIsTaxApplicable",
            InvoiceCompanyInvoiceChangeDate = "InvoiceCompanyInvoiceChangeDate",
            InvoiceCompanyIsDefault = "InvoiceCompanyIsDefault",
            InvoiceCompanyFooterNote = "InvoiceCompanyFooterNote",
            InvoiceCompanyLogo1 = "InvoiceCompanyLogo1",
            InvoiceCompanyLogo2 = "InvoiceCompanyLogo2",
            InvoiceCompanyStampImage = "InvoiceCompanyStampImage",
            InvoiceCompanyDisableInvoiceGenration = "InvoiceCompanyDisableInvoiceGenration",
            InvoiceCompanyTaxApplicable = "InvoiceCompanyTaxApplicable"
        }
    }
}
